module.exports = __webpack_public_path__ + "static/media/mouth_care.a957a0b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/activities/mouth_care.png
// module id = 1476
// module chunks = 31